var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncompleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.12931 13.9745H9.25902V11.6758C9.25902 10.833 8.95892 10.1115 8.35872 9.51128C7.75852 8.91107 7.037 8.61097 6.19417 8.61097C5.35133 8.61097 4.62981 8.91107 4.02961 9.51128C3.42941 10.1115 3.12931 10.833 3.12931 11.6758V13.9745ZM0.0644531 15.5069V13.9745H1.59688V11.6758C1.59688 10.8968 1.77886 10.1657 2.14281 9.48254C2.50676 8.79933 3.01438 8.25341 3.66566 7.84476C3.01438 7.43611 2.50676 6.89018 2.14281 6.20698C1.77886 5.52377 1.59688 4.79267 1.59688 4.01369V1.71505H0.0644531V0.182617H12.3239V1.71505H10.7915V4.01369C10.7915 4.79267 10.6095 5.52377 10.2455 6.20698C9.88157 6.89018 9.37396 7.43611 8.72267 7.84476C9.37396 8.25341 9.88157 8.79933 10.2455 9.48254C10.6095 10.1657 10.7915 10.8968 10.7915 11.6758V13.9745H12.3239V15.5069H0.0644531Z",
    fill: "#DD1515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncompleteIcon);
export default __webpack_public_path__ + "static/media/IncompleteIcon.2d39187b17881554bf08e1b17314c351.svg";
export { ForwardRef as ReactComponent };